import { getNetwork } from "../../assets/lib/networks";
import RolodexTags from "./RolodexTags.vue";
export default {
    name: "RolodexEntry",
    components: { RolodexTags },
    props: {
        entry: {
            type: Object,
        },
    },
    data() {
        return {};
    },
    computed: {
        contract() {
            if (this.entry?.type === "contract") {
                return this.entry.contract;
            }
            return null;
        },
        wallet() {
            if (this.entry?.type === "wallet") {
                return this.entry;
            }
            return null;
        },
        contractName() {
            if (this.entry?.alias) {
                return this.entry.alias;
            }
            return this.contract?.name;
        },
        contractNetwork() {
            if (this.contract) {
                return getNetwork(this.contract.network).networkName;
            }
            return null;
        },
    },
    methods: {
        edit() {
            this.$bus.emit("rolodex_address", this.entry);
        },
        select() {
            console.log("RolodexEntry click", this.entry);
            this.$emit("click", this.entry);
        },
    },
};
